function priceConverter(price) {
  if (typeof price == "undefined") return "";
  price = "" + price;
  if (price.length < 4) return price;
  let temp = [];
  while (price.length > 3) {
    temp.push(price.slice(-3));
    price = price.slice(0, -3);
  }
  temp.push(price);
  temp.reverse();
  return temp.join(",");
}

export { priceConverter };
